import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CouponCalculatorService {

  private couponResponse: any = {};
  private vatInclusive: boolean = true;
  private jobcard: any = {};


  applyCoupon(couponResponse: any, jobcard: any, vatInclusive: boolean) {
    this.couponResponse = couponResponse;
    this.jobcard = jobcard;
    this.vatInclusive = vatInclusive;
    if (!this.jobcard.id) {
      if (this.jobcard.quote.couponDiscountType === 'PERCENT') {
        this.jobcard.quote.lineItems.forEach((lineItem: any) => {
          if (this.couponResponse.coupon.linkedToProductCategories && this.couponResponse.linkedProductCategories && this.couponResponse.linkedProductCategories.length > 0) {
            if (this.couponResponse.linkedProductCategories.filter((x: any) => { return x.productCategory?.toLowerCase() === lineItem.Type?.toLowerCase(); }).length > 0) {
              this.addPercentageDiscount(lineItem);
            }
          }
          if (this.couponResponse.coupon.linkToServiceTypes && this.couponResponse.linkedServiceTypes && this.couponResponse.linkedServiceTypes.length > 0) {
            if (this.couponResponse.linkedServiceTypes.filter((x: any) => { return lineItem?.LinkedServiceTypes?.filter((y: any) => { return y.serviceTypeID === x.id; }).length > 0; }).length > 0) {
              this.addPercentageDiscount(lineItem);
            }
          }
          if (!this.couponResponse.coupon.linkToServiceTypes && !this.couponResponse.coupon.linkedToProductCategories) {
            this.addPercentageDiscount(lineItem);
          }
        });
      } else {
        if (this.couponResponse.coupon.linkedToProductCategories && this.couponResponse.linkedProductCategories && this.couponResponse.linkedProductCategories.length > 0) {
          this.jobcard.quote.lineItems.forEach((lineItem: any) => {
            if (this.couponResponse.linkedProductCategories.filter((x: any) => { return x.productCategory?.toLowerCase() === lineItem.Type?.toLowerCase(); }).length > 0) {
              this.addDiscountFixedAmount(lineItem);
            }
          });
        }
        if (this.couponResponse.coupon.linkToServiceTypes && this.couponResponse.linkedServiceTypes && this.couponResponse.linkedServiceTypes.length > 0) {
          this.jobcard.quote.lineItems.forEach((lineItem: any) => {
            if (this.couponResponse.linkedServiceTypes.filter((x: any) => { return lineItem?.LinkedServiceTypes?.filter((y: any) => { return y.serviceTypeID === x.id; }).length > 0; }).length > 0) {
              this.addDiscountFixedAmount(lineItem);
            }
          });
        }
        if (!this.couponResponse.coupon.linkToServiceTypes && !this.couponResponse.coupon.linkedToProductCategories) {

          const lineItems = this.jobcard.quote.lineItems;
          if (lineItems && lineItems.length > 0) {
            const highestPricedItem = lineItems.reduce((prev, curr) => {
              const prevPrice = (this.vatInclusive ? prev.UnitPrice_IncludingTax : prev.UnitPrice) * prev.Quantity;
              const currPrice = (this.vatInclusive ? curr.UnitPrice_IncludingTax : curr.UnitPrice) * curr.Quantity;
              return currPrice > prevPrice ? curr : prev;
            });
            this.addDiscountFixedAmount(highestPricedItem);
          }

        }
      }
    }
    this.jobcard.quote = { ...this.jobcard.quote };
  }

  addDiscountFixedAmount(lineItem: any) {
    var discountAmount = this.jobcard.quote.couponDiscount <= (this.vatInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.UnitPrice) * lineItem.Quantity ? this.jobcard.quote.couponDiscount : (this.vatInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.UnitPrice) * 1;
    var couponApplied = this.jobcard.quote.lineItems.filter((x: any) => { return (this.couponResponse.coupon.lightSpeedDiscountID != null && x.DiscountID === this.couponResponse.coupon.lightSpeedDiscountID) || x.Discount === discountAmount }).length > 0;
    if (couponApplied) {
      return;
    }
    lineItem.Discount = discountAmount;
    lineItem.TotalDiscount = lineItem.Discount;
    lineItem.DiscountID = this.couponResponse.coupon.lightSpeedDiscountID;
    lineItem.DiscountType = this.jobcard.quote.couponDiscountType;
    lineItem.CouponDiscountApplied = true;
  }

  addPercentageDiscount(lineItem: any) {
    var discountAmount = this.vatInclusive ? lineItem.UnitPrice_IncludingTax * (this.couponResponse.coupon.percentValue / 100) : lineItem.UnitPrice * (this.couponResponse.coupon.percentValue / 100);
    lineItem.Discount = discountAmount;
    lineItem.TotalDiscount = lineItem.Discount * lineItem.Quantity;
    lineItem.DiscountID = this.couponResponse.coupon.lightSpeedDiscountID;
    lineItem.DiscountType = this.jobcard.quote.couponDiscountType;
    lineItem.CouponDiscountApplied = true;
  }



}
